import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { ModalBenfeitorias } from "./ModalBenfeitorias";
import { Container } from "./styles";
import { usePrefeitura } from "../../../Hooks/usePrefeitura";
import { useCartorio } from "../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../Hooks/funcionarioCartorio";
import { useFuncionarioPrefeitura } from "../../../Hooks/funcionarioPrefeitura";
import theme from "../../../Styles/theme";
import { IBenfeitoria } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import { Edit as EditIcon } from "@mui/icons-material";
interface Props {
  benfeitorias: IBenfeitoria[];
  handleSetBenfeitorias(im: IBenfeitoria[]): void;
  editavel: boolean;
}

export function BenfeitoriasSection({
  benfeitorias,
  handleSetBenfeitorias,
  editavel,
}: Props) {
  const [openModal, setOpenModal] = useState(false);
  const { prefeituraIsLogged, checarTokenPrefeitura } = usePrefeitura();
  const { cartorioIsLogged, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  const {
    funcionarioPrefeituraIsLogged,
    checarTokenFuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();

  useEffect(() => {
    if (cartorioIsLogged) {
      checarToken();
    }
    if (funcionarioCartorioIsLogged) {
      checarTokenFuncionario();
    }
    if (prefeituraIsLogged) {
      checarTokenPrefeitura();
    }
    if (funcionarioPrefeituraIsLogged) {
      checarTokenFuncionarioPrefeitura();
    }
  }, []);

  function renderBenfeitorias() {
    if (benfeitorias && benfeitorias.length > 0) {
      return benfeitorias.map((item, index) => (
        <TableRow key={index}>
          <TableCell
            align="center"
            style={{
              border: `1px solid rgba(224, 224, 224, 1)`,
              padding: "0px",
            }}
          >
            {item.TIPO.toUpperCase()}
          </TableCell>
          <TableCell
            align="center"
            style={{
              border: `1px solid rgba(224, 224, 224, 1)`,
              padding: "0px",
            }}
          >
            {item.DESCRICAO.toUpperCase()}
          </TableCell>
          <TableCell
            align="center"
            style={{
              border: `1px solid rgba(224, 224, 224, 1)`,
              padding: "0px",
            }}
          >
            {item.MATERIAL.toUpperCase()}
          </TableCell>
          <TableCell
            align="center"
            style={{
              border: `1px solid rgba(224, 224, 224, 1)`,
              padding: "0px",
            }}
          >
            {item.AREA.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
              minimumFractionDigits: 6,
            }).replace("R$", "")}
            {item.AREA_TIPO.trim() === "M" ? "m²" : "%"}
          </TableCell>
          <TableCell
            align="center"
            style={{
              border: `1px solid rgba(224, 224, 224, 1)`,
              padding: "0px",
            }}
          >
            {item.AREA_TRANSMITIDA !== null && item.AREA_TRANSMITIDA !== undefined
              ? item.AREA_TRANSMITIDA.toLocaleString("pt-BR", {
                minimumFractionDigits: 6,
                maximumFractionDigits: 6,
              })
              : item.AREA.toLocaleString("pt-BR", {
                minimumFractionDigits: 6,
                maximumFractionDigits: 6,
              })}
            {item.AREA_TIPO.trim() === "M" ? "m²" : "%"}
          </TableCell>

          <TableCell
            align="center"
            style={{
              border: `1px solid rgba(224, 224, 224, 1)`,
              padding: "0px",
            }}
          >
            {item.ANO}
          </TableCell>
        </TableRow>
      ));
    } else {
      return (
        <TableRow>
          <TableCell colSpan={5} align="center">
            <Typography variant="body2">-</Typography>
          </TableCell>
        </TableRow>
      );
    }
  }

  return (
    <>
      {editavel ? (
        <ModalBenfeitorias
          open={openModal}
          onClose={() => setOpenModal(false)}
          benfeitorias={benfeitorias}
          handleSetBenfeitorias={handleSetBenfeitorias}
        />
      ) : (
        ""
      )}

      <Container onClick={() => setOpenModal(true)} interactive={editavel}>
        <Table
          size="small"
          style={{
            border: `1px solid rgba(224, 224, 224, 1)`,
            background: `${theme.colors.light}`,
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                align="center"
                style={{
                  border: `1px solid rgba(224, 224, 224, 1)`,

                  padding: "0px",
                }}
              >
                TIPO
              </TableCell>
              <TableCell
                align="center"
                style={{
                  border: `1px solid rgba(224, 224, 224, 1)`,
                  padding: "0px",
                }}
              >
                DESCRIÇÃO
              </TableCell>
              <TableCell
                align="center"
                style={{
                  border: `1px solid rgba(224, 224, 224, 1)`,
                  padding: "0px",
                }}
              >
                MATERIAL
              </TableCell>
              <TableCell
                align="center"
                style={{
                  border: `1px solid rgba(224, 224, 224, 1)`,
                  padding: "0px",
                }}
              >
                ÁREA TOTAL
              </TableCell>
              <TableCell
                align="center"
                style={{
                  border: `1px solid rgba(224, 224, 224, 1)`,
                  padding: "0px",
                }}
              >
                ÁREA TRANSMITIDA
              </TableCell>
              <TableCell
                align="center"
                style={{
                  border: `1px solid rgba(224, 224, 224, 1)`,
                  padding: "0px",
                }}
              >
                ANO
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderBenfeitorias()}</TableBody>
        </Table>
      </Container>
      {editavel && <div
        style={{ width: "100%", display: "flex", justifyContent: "center" }}
      >
        <Button
          variant="contained"
          color="primary"
          startIcon={<EditIcon />}
          onClick={() => {
            // setAdquirenteFocus({} as IAdquirinte);
            setOpenModal(true);
          }}
          style={{ marginTop: "4px", minWidth: "300px" }}
        >
          EDITAR BENFEITORIAS
        </Button>
      </div>}

    </>
  );
}
